import React from "react";
import DisplacementSphere from "../components/background/DisplacementSphere";

export const Resume = () => {
  return <DisplacementSphere />;
};
